import { Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import {default as RouteGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Routes-Columns.json';
import {default as TradeGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Trades-Columns.json';
import {default as OrderGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Orders-Columns.json';
import {default as CATGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CAT-ROE-Viewer-Columns.json';
import {default as DefaultFilterJSON} from 'app/Shared/Constant/Default Filter JSON/Details-Order-Viewer.json';

import { DataService } from 'app/Shared/Services/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormsModule, NgModel } from '@angular/forms';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Observable, forkJoin } from 'rxjs';
import { TurboTableComponent } from '../turbo-table/turbo-table.component';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { DialogModule } from 'primeng/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-order-viewer',
    templateUrl: './order-viewer.component.html',
    imports: [TurboTableComponent, MatCheckboxModule, MatAccordion, MatExpansionModule, MatChipsModule, MatProgressSpinner, MatTabsModule, DialogModule, MatTooltipModule, FormsModule, ButtonModule, CommonModule, ToastModule],
    providers: [],
    styleUrls: ['./order-viewer.component.scss']
})
export class OrderViewerComponent implements OnInit,OnDestroy {
  @Input('DefaultFilterArray') DefaultFilterArray: any = [];
  @Input('isOpenClose') isOpenClose!: boolean;
  @Input('SelectedRow') SelectedRow: any = [];
  @Input('PageName') PageName: any;
  @Output() CloseEvent: EventEmitter<any> = new EventEmitter();
  DefaultFilterColumns;
  public FilterData: any = [];
  fromdate:any;
  todate:any;
  OrderGridCols: any = [];
  TradeGridCols: any = [];
  RouteGridCols: any = [];
  CATGridCols: any = [];
  OrderGridColumns: any = [];
  TradeGridColumns: any = [];
  RouteGridColumns: any = [];
  CATGridColumns: any = [];
  OrderCSVGridHeaders: any = [];
  TradeCSVGridHeaders: any = [];
  RouteCSVGridHeaders: any = [];
  CATCSVGridHeaders: any = [];
  OrderCSVGridFields: any = [];
  TradeCSVGridFields: any = [];
  RouteCSVGridFields: any = [];
  CATCSVGridFields: any = [];
  Dataset: any = [];
  panelOpenState: boolean = true;
  FilterpanelOpenState: boolean = true;
  checkedMatchUsingSymbol: boolean = true;
  checkedTrade: boolean = true;
  checkedRoute: boolean = true;
  checkedAccordationView: boolean = true;
  selectedTab = new FormControl(0);
  labelPosition = 'after';
  Limit: any = { 'Start': '0', 'End': '20' };
  CSVLimit: any = { 'Start': '0', 'End': '20' };
  Tradedataset: any = [];
  Orderdataset: any = [];
  Routedataset: any = [];
  CATdataset: any = [];
  isOrderdatasetLoading!: boolean;
  isTradedatasetLoading!: boolean;
  isRoutedatasetLoading!: boolean;
  isCATdatasetLoading!: boolean;
  TempFilterArray: any = [];
  eventType: any;
  subscription: any;
  OrderId: any;
  OSMId!: string;
  ComplianceOrderId: any;
  Symbol: any;
  CancelOrderID:any;
  OrderIDList:any;
  expandedPanel: boolean[] = [true];

  constructor(
    private datePipe: DatePipe,
    private gridService: GridService,
    private emitterService: EmitterService,
    private dataService: DataService,
    public constantService: ConstantService,
    private route: ActivatedRoute,
    public UserService: UserService,
    private messageService: MessageService) {
    window.scrollTo(0, 0);
    this.OrderGridColumns = OrderGridColumnsJSON["Orders-Grid-Columns"];
    this.TradeGridColumns = TradeGridColumnsJSON["Trades-Grid-Columns"];
    this.RouteGridColumns = RouteGridColumnsJSON["Routes-Grid-Columns"];
    this.CATGridColumns = CATGridColumnsJSON["CAT-ROE-Grid-Columns"];
    this.DefaultFilterColumns = DefaultFilterJSON;
    this.OrderGridCols = this.gridService.getGridColumns(this.OrderGridColumns);
    this.TradeGridCols = this.gridService.getGridColumns(this.TradeGridColumns);
    this.RouteGridCols = this.gridService.getGridColumns(this.RouteGridColumns);
    this.CATGridCols = this.gridService.getGridColumns(this.CATGridColumns);
    this.CATGridCols.splice(0, 1); // *** note removed action column */

    // Order Viewer CSV Header & Fields
    [this.CATCSVGridHeaders, this.CATCSVGridFields] = [
      this.CATGridCols.filter((gridItem: { display: string; }) => gridItem.display !== 'false').map((gridItem: { [x: string]: any; }) => gridItem["header"]),
      this.CATGridCols.filter((gridItem: { display: string; }) => gridItem.display !== 'false').map((gridItem: { [x: string]: any; }) => gridItem["field"])
    ];
    [this.OrderCSVGridHeaders, this.OrderCSVGridFields] = [this.OrderGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["header"]}), this.OrderGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["field"]})];
    [this.TradeCSVGridHeaders, this.TradeCSVGridFields] = [this.TradeGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["header"]}), this.TradeGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["field"]})];
    [this.RouteCSVGridHeaders, this.RouteCSVGridFields] = [this.RouteGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["header"]}), this.RouteGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["field"]})];
  }

  ngOnInit() {
    this.selectedTab.setValue(0);
    this.subscription = this.emitterService.isOrderViewerOpenCloseEvent.subscribe({
      next: (event: any) => {
        this.checkedMatchUsingSymbol = true;
        this.checkedTrade = true;
        this.checkedRoute = true;
        if (event.display == true) {
          this.PageName = event.pageName;
          this.isOpenClose = event.display;
          this.SelectedRow[0] = event.rowData;
          this.setFilterArrayValue(this.SelectedRow[0]);
          this.openAccordion();
          if(this.PageName=='Order' || this.PageName=='Trade' || this.PageName=='Route'){
            this.getOrderIDList();
          }else {
            this.OrderIDList=this.OrderId;
            this.getOrderViewerCATData();
            this.getOrderViewerOrderData();
            this.getOrderViewerRouteData();
            this.getOrderViewerTradeData();
          }

        }
      }
    });
  }

  toggleMatchSymbol(event: MatCheckboxChange): void {
      this.Symbol = ((event.checked) ? this.SelectedRow[0]['symbol'] : '');

    this.openAccordion();

    if(this.PageName=='Order' || this.PageName=='Trade' || this.PageName=='Route'){
      this.getOrderIDList();
    } else {
      this.OrderIDList = this.OrderId;
      this.getOrderViewerCATData();
      this.getOrderViewerOrderData();
      this.getOrderViewerRouteData();
      this.getOrderViewerTradeData();
    }
  }

  closeDialogbox() {
    this.isOpenClose = false;
    this.closeAccordion();
    this.checkedAccordationView = true;
    this.panelOpenState = true;
    this.FilterData = [];
    this.SelectedRow = [];
    this.Orderdataset = [];
    this.Tradedataset = [];
    this.Routedataset = [];
    this.CATdataset = [];
  }
 

  setFilterArrayValue(Data: any) {
    let rowObj = Data;
    this.OrderId = "";
    this.OSMId = "";
    this.ComplianceOrderId = "";
    this.Symbol = "";
    if (rowObj != null) {
      let fromdate:any;
      let todate:any;
      if (this.PageName == 'Order') {
        fromdate = (rowObj['orderDate']);
        todate = (rowObj['orderDate']);
        this.eventType = "All";
        this.OSMId = "";//ComplianceOrderIdomsOrderID
        this.OrderId = rowObj['orderID'];
        this.Symbol = rowObj['symbol'];
        this.CancelOrderID = rowObj['cancelOrderID']; 
        this.ComplianceOrderId = this.OrderId;
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      }
      else if (this.PageName == 'Trade') {
        fromdate = (rowObj['tradeDate']);
        todate = (rowObj['tradeDate']);
        this.eventType = "All";
        this.OrderId = rowObj['orderID'] ;
        this.OSMId =  "";
        this.ComplianceOrderId = this.OrderId;
        this.Symbol = rowObj['symbol'];
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      }
      else if (this.PageName == 'Route') {
        fromdate = (rowObj['routeDate']);
        todate = (rowObj['routeDate']);
        this.eventType = "All";
        this.OrderId =  rowObj['orderID'];
        this.OSMId = "";
        this.ComplianceOrderId = this.OrderId;
        this.Symbol = rowObj['symbol'];
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      }
      else if (this.PageName == "CAT-Exception") {
        fromdate = (rowObj['orderKeyDate']);
        todate = (rowObj['reportDate']);
        this.eventType = "All";
        this.OrderId =  rowObj['orderID'];
        this.ComplianceOrderId = rowObj['orderID'];
        this.Symbol = rowObj['symbol'];
        this.OSMId = rowObj['orderID'];
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      } else if (this.PageName == 'CAT-ROE') {
        fromdate = (rowObj['orderKeyDate']);
        todate = (rowObj['reportDate']);
        this.eventType = "All";
        this.OrderId =  rowObj['orderID'];
        this.ComplianceOrderId = rowObj['orderID'];
        this.Symbol = rowObj['symbol'];
        this.OSMId = rowObj['orderID'];
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      }
      else if (this.PageName == 'Reg-Sho') {
        todate = (rowObj['ExecutedDate']);
        this.eventType = "All";
        this.fromdate = this.UserService.getyyyyMMddDate(todate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
        this.OrderId = rowObj['orderID'];
        this.OSMId = "";
        this.ComplianceOrderId = rowObj['OrderID'];//Added ComplianceOrderId ID as Order ID""
        this.Symbol = rowObj['Symbol'];
      } else if (this.PageName == "Finra-Exception") {
        fromdate = (rowObj['orderKeyDate'] && rowObj['orderKeyDate'].trim().length > 0) ? (rowObj['orderKeyDate']) : (rowObj['reportDate']);
        todate = (rowObj['reportDate']);
        this.eventType = "All";
        this.OrderId =  rowObj['orderID'];
        this.ComplianceOrderId = rowObj['orderID'];
        this.Symbol = rowObj['symbol'];
        this.OSMId = rowObj['orderID'];
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      }
      else if (this.PageName == 'Allocation') {
        todate = (rowObj['AllocationDate']);
        this.eventType = "All";
        this.OSMId = "";//ComplianceOrderIdomsOrderID
        this.OrderId = rowObj['OrderID'];
        this.Symbol = rowObj['Symbol'];
        this.ComplianceOrderId = this.OrderId;
        this.fromdate = this.UserService.getyyyyMMddDate(todate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
        this.PageName='CAT-ROE'
      }
      else if (this.PageName == 'CAT-RECON') {
        todate = (rowObj['ReportDate']);
        this.eventType = "All";
        this.OrderId =  rowObj['orderID'];
        this.ComplianceOrderId = rowObj['orderID'];
        this.Symbol = rowObj['symbol'];
        this.OSMId = rowObj['orderID'];
        this.fromdate = this.UserService.getyyyyMMddDate(todate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      }
      else if (this.PageName == "Comparative-Review-Exception") {
        fromdate = (rowObj['reportDate']);
        todate = (rowObj['reportDate']);
        this.eventType = "All";
        this.OrderId =  rowObj['orderID'];
        this.ComplianceOrderId = rowObj['orderID'];
        this.Symbol = rowObj['symbol'];
        this.OSMId = rowObj['orderID'];
        this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
        this.todate = this.UserService.getyyyyMMddDate(todate);
      } 
    }
    let ydate= new Date(this.fromdate);
    this.fromdate=this.datePipe.transform(new Date(ydate.setDate(ydate.getDate() - 1)), "yyyy-MM-dd");
  }

  getOrderIDList() {
      this.isCATdatasetLoading=true;
      this.dataService.getOrderIDList( this.fromdate, this.todate, this.OrderId, this.Symbol, this.PageName)
      .subscribe({
        next: (Element: any) => {
        this.isCATdatasetLoading=false;
          let dataset: any = Element;
          this.OrderIDList=dataset.response.orderIDList;
          this.getOrderViewerCATData();
          this.getOrderViewerOrderData();
          this.getOrderViewerRouteData();
          this.getOrderViewerTradeData();
        },  error: (err: HttpErrorResponse) => {
          this.isCATdatasetLoading=false;
        }});
  }

  getOrderViewerCATData() {
    this.isCATdatasetLoading=true;
    this.dataService.getOrderViewerCATData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.Limit, this.PageName)
      .subscribe({
        next: (Element:any) => {
          this.isCATdatasetLoading = false;
          let dataset: any = Element;
          this.CATdataset = [];
          this.CATdataset = dataset.response.Data;
        }, error: (err: HttpErrorResponse) => {
          this.isCATdatasetLoading = false;
        }});
  }

  getOrderViewerOrderData() {
    this.isOrderdatasetLoading=false;
    this.dataService.getOrderViewerOrderData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.Limit, this.PageName)
      .subscribe({
          next: (Element:any) => {
          this.isOrderdatasetLoading = false;
          let dataset: any = Element;
          this.Orderdataset = [];
          this.Orderdataset = dataset.response.Data;
        }, error: (err: HttpErrorResponse) => {
          this.isOrderdatasetLoading = false;
        }});
  }

  getOrderViewerTradeData() {
    this.isTradedatasetLoading=false;
    this.dataService.getOrderViewerTradeData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.Limit, this.PageName)
      .subscribe({
          next: (Element:any) => {
          this.isTradedatasetLoading = false;
          let dataset: any = Element;
          this.Tradedataset = [];
          this.Tradedataset = dataset.response.Data;
        }, error: (err: HttpErrorResponse) => {
          this.isTradedatasetLoading = false;
        }});
  }

  getOrderViewerRouteData() {
    this.isRoutedatasetLoading=true;
    this.dataService.getOrderViewerRouteData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.Limit, this.PageName)
      .subscribe({
          next: (Element:any) => {
          this.isRoutedatasetLoading = false;
          let dataset: any = Element;
          this.Routedataset = [];
          this.Routedataset = dataset.response.Data;
        }, error: (err: HttpErrorResponse) => {
          this.isRoutedatasetLoading = false;
        }});
  }

  exportToCSV(pageType: string) {
    if(this.UserService.enableFileExport()){
    // to let user know the button is clicked and download process is started
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    if (pageType && pageType==='All') {
      this.CSVLimit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else if (pageType && pageType==='Current') {
      this.CSVLimit = { 'Start': '0', 'End': '20' };
    }

    this.isCATdatasetLoading = true;

    forkJoin([
      this.dataService.getOrderViewerCATData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.CSVLimit, this.PageName),
      this.dataService.getOrderViewerOrderData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.CSVLimit, this.PageName),
      this.dataService.getOrderViewerTradeData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.CSVLimit, this.PageName),
      this.dataService.getOrderViewerRouteData(this.fromdate, this.todate, this.OrderIDList, this.Symbol, this.CSVLimit, this.PageName)
      ]
    ).subscribe({
      next: (responseSet:any) => {
      this.exportCSV(responseSet[0].response.Data, responseSet[1].response.Data, responseSet[2].response.Data, responseSet[3].response.Data);
      this.isCATdatasetLoading = false;
    }, error: (err: HttpErrorResponse) => {
      this.isCATdatasetLoading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(JSON.parse(JSON.stringify(this.DefaultFilterArray)).filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});

  }
}

  exportCSV(CATdataset: string | any[], Orderdataset: string | any[], Tradedataset: string | any[], Routedataset: string | any[]) {
     if(this.UserService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData.values.length === 2) {
      filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    // Export Order Viewer Detail CSV
    if(CATdataset.length===0 && Orderdataset.length===0 && Tradedataset.length===0 && Routedataset.length===0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'No data found',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    } else {
      let CSVData = "";
      let CATTableData: any[] = [], OrderTableData: any[] = [], TradeTableData: any[] = [], RouteTableData: any[] = [];
      if(CATdataset.length > 0) {
        CATTableData = this.prepareCSVDataSet(this.CATCSVGridHeaders, this.CATCSVGridFields, CATdataset);
      }
      if(Orderdataset.length > 0) {
        OrderTableData = this.prepareCSVDataSet(this.OrderCSVGridHeaders, this.OrderCSVGridFields, Orderdataset);
      }
      if(Tradedataset.length > 0) {
        TradeTableData = this.prepareCSVDataSet(this.TradeCSVGridHeaders, this.TradeCSVGridFields, Tradedataset);
      }
      if(Routedataset.length > 0) {
        RouteTableData = this.prepareCSVDataSet(this.RouteCSVGridHeaders, this.RouteCSVGridFields, Routedataset);
      }
      CSVData += 'RSMS_Order_Viewer_Detail_' + this.UserService.getyyyyMMddDateFormate(new Date()) + "\n\n";
      CSVData += "************CAT Data************\n\n";
      CSVData += (CATTableData.length > 0 ? CATTableData.join("\n") : "No Data Found") + "\n\n\n";
      CSVData += "************Order Data************\n\n";
      CSVData += (OrderTableData.length > 0 ? OrderTableData.join("\n") : "No Data Found") + "\n\n\n";
      CSVData += "************Trade Data************\n\n";
      CSVData += (TradeTableData.length > 0 ? TradeTableData.join("\n") : "No Data Found") + "\n\n\n";
      CSVData += "************Route Data************\n\n";
      CSVData += (RouteTableData.length > 0 ? RouteTableData.join("\n") : "No Data Found");

      let fileName = this.UserService.getActiveMPID() + '_RSMS_Order_Viewer_' + this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()) + ".csv";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([CSVData], { type: "text/csv" }));
      a.setAttribute("download", fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'File Download Successfully | CAT Data Count: ' + (this.CATdataset.length > 0 ? this.CATdataset.length : 0) + ', Order Data Count: ' + (this.Orderdataset.length > 0 ? this.Orderdataset.length : 0) + ', Trader Data Count: ' + (this.Tradedataset.length > 0 ? this.Tradedataset.length : 0) + ', Route Data Count: ' + (this.Routedataset.length > 0 ? this.Routedataset.length : 0) + ' records downloaded with file name: ' + fileName + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }
  }
  }

  parseCell (ObjectValue: string) {
    // Replace all double quotes with two double quotes
    let parsedValue = ObjectValue.replace(/"/g, `""`);

    // If value contains comma, new-line or double-quote, enclose in double quotes
    parsedValue = /[",\n]/.test(parsedValue) ? `"${parsedValue}"` : parsedValue;

    return parsedValue;
  }

  prepareCSVDataSet(dataSetHeaders: any[], dataSetFields: string | any[], dataSet: any) {
    const tableData = [];

    tableData.push(dataSetHeaders.join(",")); // CSV Header
    // CSV Body
    for (const row of dataSet) {
      const rowData = [];
      for(let i=0; i < dataSetFields.length; i++) {
        rowData.push(((row[dataSetFields[i]] !== null && row[dataSetFields[i]] !== undefined) ? this.parseCell(row[dataSetFields[i]].toString()) : ""));
      }
      tableData.push(rowData.join(","));
    }

    return tableData;
  }

  closeAccordion() {
    this.expandedPanel.fill(false); 
  }

  openAccordion() {
    this.expandedPanel.fill(true); 
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}